import moment from 'moment'

export const formatDate = (date) =>
  moment(date, 'YYYYMMDD').format('MM/DD/YYYY')

export const formatDateY = (date) =>
  moment(date).format('YYYY/MM/DD')
